import {
  EDITOR_MODE,
  ViewerStateWithSyncer,
  useEditorContent,
  useEditorDispatch,
  useEditorMode
} from "@pathwright/blocks-engine"
import useScrollToAndHighlight from "@pathwright/ui/src/components/link/useScrollToAndHighlight"
import { LazyQuillEditor } from "@pathwright/ui/src/components/quill/LazyQuillEditor"
import View from "@pathwright/ui/src/components/ui/View"
import { usePreload } from "@pathwright/ui/src/components/utils/preload"
import ErrorOverlay from "../ui/ErrorOverlay"
import { DefaultLoadingWithTimeout } from "../utils/LoadingWithTimeout"
import { ContentViewer } from "../viewer/ContentViewer"
import ContentEditorBlocks from "./ContentEditorBlocks"
import ContentEditorControls from "./ContentEditorControls"

export const ContentEditor = () => {
  const { mode } = useEditorMode()
  const { error, contentLoading } = useEditorContent()
  const { handleBlockChange } = useEditorDispatch()

  useScrollToAndHighlight({
    scrollDuration: 700,
    offset: 100,
    autofocus: false
  })

  // Optimistic user scoped update for Editor Preview mode
  const handleViewerBlockChange = (data, id, trackProgress) => {
    handleBlockChange(data, id, trackProgress)
  }

  // HACK: showing loader until QuillEditor is loaded for a more
  // seemless transition from loading to displaying content
  const [preloading] = usePreload({
    Component: LazyQuillEditor,
    preload: true
  })

  if ((preloading && process.env.NODE_ENV !== "test") || contentLoading)
    return <DefaultLoadingWithTimeout />

  return (
    <View.Primary
      id="blocks-content-editor"
      style={{
        minHeight: error ? "450px" : null,
        position: "relative",
        boxShadow: mode === "edit" ? "0 0 3px 1px rgba(0,0,0,0.1)" : "none"
      }}
    >
      {error && (
        <ErrorOverlay
          error={error}
          explanation={
            error.includes("publish")
              ? "Please add blocks and try publishing again."
              : ""
          }
        />
      )}
      <ContentEditorControls />
      {mode === EDITOR_MODE.VIEW ? (
        // Editor preview mode
        <ViewerStateWithSyncer
          draft={true} // This allows student data to be saved on draft blocks
        >
          <ContentViewer onBlockChange={handleViewerBlockChange} />
        </ViewerStateWithSyncer>
      ) : (
        <ContentEditorBlocks key={`blocks-${mode}`} />
      )}
    </View.Primary>
  )
}
